import React from "react"
import classes from "./ShowOTPPopup.module.css"
import Button1 from "../../../../Button/Button1";
import { Button } from "primereact/button";

const ShowOTPPopup = ({pincode, closeModal}) => {




  return (
    <>
      <div className={classes.OTPCodeContainer}>
        <div className={classes.copyButtonContainer}>
          
        </div>

        <div className={classes.pincodeTextContainer}>
            <h1>{pincode}</h1>
          
        </div> 

        <div className={classes.buttonsContainer}>
            <Button  icon="pi pi-times" onClick={closeModal} label="Close" severity='secondary'/>
            
          </div>
      </div>
    </>
  );
}

export default ShowOTPPopup